// it's important for our shopify app that we keep the shop and host searchParams
// when navigating within our app.
// this helper function sets the shopify host id and shop search parameters
// on a relative url
export function shopifyRelativeUrl (path: string, currentLocation: Location) {
  const currentSearchParams = new URL(currentLocation.href).searchParams;
  const host = currentSearchParams.get('host');
  const shop = currentSearchParams.get('shop');
  if (!host || !shop) {
    throw new Error('creating shopify url without host or shop parameter');
  }
  const url = new URL(path, currentLocation.origin);
  url.searchParams.append('host', host);
  url.searchParams.append('shop', shop);
  return url.pathname + url.search;
}
